import React from 'react';

import styled from 'styled-components';

import { showDate, showDateNoTime } from '@libs/NwMoment';

import CreatedBy from '@components/CreatedBy/CreatedBy';
import NwDivider from '@components/Gui/NwDivider';
import NwEllipsis from '@components/Gui/NwEllipsis';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    .project-models {
        cursor: pointer;
        padding: 10px;
        margin-bottom: 10px;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        display: flex;
        align-items: center;
        gap: 10px;

        &.selected {
            background-color: ${(props) => props.theme.PrimaryColorLight};
            border-color: ${(props) => props.theme.PrimaryColor};
        }

        p {
            margin: 0;
            font-size: ${(props) => props.theme.FontSizeBase};
        }
    }

    .project-shortlists-selector {
        margin-top: 1rem;
    }

    .project-shortlists-package {
        margin-bottom: 2rem;
        /* border: 1px solid #e8e8e8;
        border-radius: 4px; */

        .project-shortlists-package-details {
            padding: 0.75rem;
            /* background-color: #fafafa;
            border-bottom: 1px solid #e8e8e8; */

            .project-shortlists-package-details-header {
                display: flex;
                align-items: center;
                gap: 0.75rem;

                p {
                    margin: 0;
                    font-weight: 500;
                    flex: 1;
                }
            }

            .created-by {
                font-size: ${(props) => props.theme.FontSizeSm};
                color: ${(props) => props.theme.TextColorMuted};
            }
        }

        .project-shortlists-package-recipients {
            padding: 0.5rem 0 0 1.5rem;

            .project-shortlists-package-recipient {
                margin-bottom: 1rem;

                .project-shortlists-package-recipient-header {
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    margin-bottom: 0.5rem;

                    p {
                        margin: 0;
                    }
                }

                .project-shortlists-package-recipient-shortlist {
                    cursor: pointer;
                    margin: 0.5rem 0 0 0;
                    border: 1px solid #e8e8e8;
                    border-radius: 4px;
                    padding: 0.5rem 1rem;
                    transition: all 0.3s ease;

                    &.selected {
                        background-color: ${(props) => props.theme.PrimaryColorLight};
                        border-color: ${(props) => props.theme.PrimaryColor};
                    }

                    .project-shortlists-package-recipient-shortlist-header {
                        display: flex;
                        align-items: center;
                        gap: 0.75rem;

                        p {
                            font-size: ${(props) => props.theme.FontSizeSm};
                            font-weight: 600;
                            margin: 0;
                        }

                        .shortlist-message {
                            font-size: ${(props) => props.theme.FontSizeBase};
                            font-style: italic;
                            margin: 0.75rem 0;
                        }
                    }

                    .project-shortlists-package-recipient-shortlist-content {
                        padding-left: 1.8rem;
                        font-size: ${(props) => props.theme.FontSizeSm};

                        p {
                            margin: 0;
                        }
                    }

                    .project-shortlists-package-recipient-shortlist-groups {
                        margin-top: 0.75rem;
                        padding-left: 1.8rem;
                        display: flex;
                        flex-direction: column;
                        gap: 0.5rem;

                        .shortlist-group-item {
                            cursor: pointer;
                            padding: 0.5rem 0.75rem;
                            border: 1px solid #e8e8e8;
                            border-radius: 4px;
                            background-color: #fafafa;
                            transition: all 0.3s ease;
                            display: flex;
                            align-items: center;
                            gap: 0.5rem;

                            &:hover {
                                background-color: #f0f0f0;
                                border-color: #d0d0d0;
                            }

                            &.selected {
                                background-color: ${(props) => props.theme.PrimaryColorLight};
                                border-color: ${(props) => props.theme.PrimaryColor};
                            }

                            p {
                                margin: 0;
                                font-size: ${(props) => props.theme.FontSizeSm};
                                font-weight: 500;
                            }

                            .group-count {
                                margin-left: auto;
                                font-size: ${(props) => props.theme.FontSizeXs};
                                color: ${(props) => props.theme.TextColorMuted};
                            }
                        }
                    }
                }
            }
        }
    }
`;

const ContactsFilterProject = ({ onSelectShortlist, projectShortlists, shortlistId, selectedGroupName }) => {
    // Funzione per raggruppare gli items di una shortlist per Group
    const getShortlistGroups = (shortlist) => {
        const hasGroups = shortlist.Items.some((item) => item.Group);

        if (!hasGroups) {
            return null;
        }

        const grouped = shortlist.Items.reduce((acc, item) => {
            const groupName = item.Group || 'Senza Gruppo';
            if (!acc[groupName]) {
                acc[groupName] = [];
            }
            acc[groupName].push(item);
            return acc;
        }, {});

        return Object.keys(grouped)
            .sort()
            .map((groupName) => ({
                name: groupName,
                count: grouped[groupName].length,
            }));
    };

    return (
        <Wrapper>
            <div
                className={`project-models ${shortlistId === null ? 'selected' : ''}`}
                onClick={() => onSelectShortlist(null, null)}
            >
                <NwIcon icon={byPrefixAndName.fasl['folder']} />
                <p>all models in current project</p>
            </div>
            {projectShortlists && projectShortlists.length > 0 && (
                <div className="project-shortlists-selector">
                    <NwDivider>Packages with shortlists</NwDivider>
                    {projectShortlists.map((shortlistPackage) => (
                        <div className="project-shortlists-package" key={`pack-${shortlistPackage.ID}`}>
                            <div className="project-shortlists-package-details">
                                <div className="project-shortlists-package-details-header">
                                    <NwIcon icon={byPrefixAndName.fasl['book-arrow-right']} />
                                    <p>{shortlistPackage.Name}</p>
                                </div>
                                <CreatedBy object={shortlistPackage} />
                            </div>
                            <div className="project-shortlists-package-recipients">
                                {shortlistPackage.Recipients.map((recipient) => (
                                    <div
                                        className="project-shortlists-package-recipient"
                                        key={`recipient-${recipient.ID}`}
                                    >
                                        <div className="project-shortlists-package-recipient-header">
                                            <NwIcon icon={byPrefixAndName.fasl['mailbox']} />

                                            <p>{recipient.Email}</p>
                                        </div>
                                        {recipient.Shortlists.map((shortlist) => {
                                            const groups = getShortlistGroups(shortlist);
                                            const isShortlistSelected =
                                                shortlist.ID === shortlistId && !selectedGroupName;

                                            return (
                                                <div key={`shortlist-${shortlist.ID}`}>
                                                    <div
                                                        className={`project-shortlists-package-recipient-shortlist ${isShortlistSelected ? 'selected' : ''}`}
                                                        onClick={() => onSelectShortlist(shortlist.ID, null)}
                                                    >
                                                        <div className="project-shortlists-package-recipient-shortlist-header">
                                                            <NwIcon icon={byPrefixAndName.fasl['heart']} />
                                                            <p>
                                                                {showDate(shortlist.DateCreated)} -{' '}
                                                                {shortlist.Items.length} models
                                                            </p>
                                                        </div>
                                                        <div className="project-shortlists-package-recipient-shortlist-content">
                                                            <NwEllipsis
                                                                className="shortlist-message"
                                                                text={shortlist.Message}
                                                                popover
                                                                rows={3}
                                                            />
                                                        </div>
                                                        {groups && (
                                                            <div className="project-shortlists-package-recipient-shortlist-groups">
                                                                {groups.map((group) => {
                                                                    const isGroupSelected =
                                                                        shortlist.ID === shortlistId &&
                                                                        selectedGroupName === group.name;

                                                                    return (
                                                                        <div
                                                                            key={`group-${group.name}`}
                                                                            className={`shortlist-group-item ${isGroupSelected ? 'selected' : ''}`}
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                onSelectShortlist(
                                                                                    shortlist.ID,
                                                                                    group.name
                                                                                );
                                                                            }}
                                                                        >
                                                                            <NwIcon
                                                                                icon={
                                                                                    byPrefixAndName.fasl['layer-group']
                                                                                }
                                                                            />
                                                                            <p>{group.name}</p>
                                                                            <span className="group-count">
                                                                                {group.count} models
                                                                            </span>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </Wrapper>
    );
};

export default ContactsFilterProject;
